export class ValidationUtils {
  public static isNonEmptyArray(value: any[]): boolean {
    return !!value && value.length > 0;
  }
}
